import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardFormStepSelectorComponent } from '@app/theme/wizard-form/wizard-form-step-selector/wizard-form-step-selector.component';
import { WizardFormComponent } from '@app/theme/wizard-form/wizard-form.component';
import { FormStepDirective } from './directives/form-step/form-step.directive';

@NgModule({
  declarations: [FormStepDirective, WizardFormComponent, WizardFormStepSelectorComponent],
  imports: [CommonModule],
  exports: [WizardFormComponent],
})
export class WizardFormModule {}
